import {Observable} from 'rxjs';
import {jobHunterAPI, RestQueryParams} from 'jobhunter-common-web';

export function confirmPaymentAPI(authToken: string | null, paymentId: string): Observable<any> {
    let headers = undefined;

    if (authToken) {
        headers = {
            Authorization: `Bearer ${authToken}`,
        };
    }

    return jobHunterAPI.put(`api/payments/${paymentId}/confirm`, {}, new RestQueryParams(), headers);
}
